import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { of } from 'rxjs';

export const StudentGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const authService: AuthService = inject(AuthService);
    const platformId = inject(PLATFORM_ID);

    if (!isPlatformBrowser(platformId)) {
        return of(true);
    }

    const userRole = authService.getRole();

    if (authService.getToken() && userRole === 'student') {
        return of(true);
    }

    // Redirect to a default page if the role doesn't match
    const urlTree = router.parseUrl('');
    return of(urlTree);
};